import mapPeCompanyDetailFromApi from 'rtkQuery/sharespro/mapper/modules/pe/peCompany/mapPeCompanyDetailFromApi';
import mapChartDataFromApi from 'rtkQuery/sharespro/mapper/shared/mapChartDataFromApi';

const mapPeDealDetailFromApi = (resp: ApiPeDealDetail): PeDealDetail => {
  return {
    id: resp.id,
    company: mapPeCompanyDetailFromApi(resp.company),
    chartData: mapChartDataFromApi(resp.chart),
  };
};

export default mapPeDealDetailFromApi;
